import { InjectionToken } from '@angular/core';

export class AppConfig {
    useMock: boolean;
    production: boolean;
    oktaLogin: boolean;
    passwordlessAuth: boolean;
    showAskHestiaChatWidget: boolean;
    policyOrchestratorUrl: string;
    policyOrchestratorThirdPartyUrl?: string;
    policyOrchestratorApiKey: string;
    letterOfExperienceUrl: string;
    callSummaryApi: string;
    callAttributesApi: string;
    callSummaryApiKey: string;
    callIntentApi: string;
    quoteURL: string;
    policyURL: string;
    agencyURL: string;
    apiRedirectUrl: string;
    appURL: string;
    docViewAPI: string;
    okta: {
        baseURL: string;
        clientId: string;
        issuer: string;
        scopes: string[];
        logo: string;
        pkce: boolean;
        redirectUri: string;
        settingsURL: string;
    };
    launcherURL: string;
    ArenderURL: string;
    ArenderProp: string;
    reCaptchaKey: string;
    emailUrl: string;
    apiKey: string;
    emailVerificationURL: string;
    emailVerificationKey: string;
    smsOrchestratorURL: string;
    thirdPartyLoginURL: string;
    smsPaymentLink: string;
    amsPortalUrl: string;
    quickSightChat: {
        region: string;
        accountId: string;
        agentId: string;
        embedUrlApi: string;
        apiKey: string;
    };
    irisTaskURL: string;
    irisBaseURL: string;
    irisApiKey: string;
    getPolicyDataURL: string;
    irisApiURL: string;
    theme: string;
    phoneSearchApi: string;
    phoneSearchApiKey: string;
    Moratorium_API: string;
    verifyContactUrl: string;
    verifyContactApiKey: string;
    addNotesUrl: string;
    quoteSearchApi: string;
    updateContact: string;
    updateContactApiKey: string;
    authSessionUrl: string;
    authSessionApiKey: string;
    portletUrl: string;

    // --- Tracking / audit pipeline (PRODSUPP-145765) ---
    /** Master on/off switch for the tracking pipeline. */
    trackingEnabled?: boolean;
    /**
     * Endpoint for the Policy360Orchestrator `policy360-audit` action that
     * ingests batched tracking events and writes them to Elasticsearch.
     */
    trackingIngestUrl?: string;
    /** API key for the tracking ingest endpoint. */
    trackingApiKey?: string;
    /** Flush when the buffer reaches this many events. */
    trackingBatchSize?: number;
    /** Flush at least this often (milliseconds), even below the batch size. */
    trackingFlushIntervalMs?: number;
    /** Hard cap on buffered events; oldest are dropped past this limit. */
    trackingMaxBufferSize?: number;
    /**
     * Regex patterns (as strings, matched case-insensitively against the request
     * URL path) for requests that must NOT be audited — e.g. static assets and
     * local mocks. When omitted, a built-in default list is used.
     */
    trackingExcludePatterns?: string[];
}

export let APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');
